import React from 'react';

const InfoCard = ({ icon: Icon, label, value }) => {
    const renderValue = (val) => {
        if (!val) return '';
        if (Array.isArray(val)) {
            return val.map(item => item.value || item).join(', ');
        }
        if (typeof val === 'object') {
            return val.value || JSON.stringify(val);
        }
        return val;
    };

    return (
        <div className="flex flex-col sm:flex-row items-start gap-4 hover:bg-gray-50 p-3 rounded-xl transition-colors">
            <div className="w-12 h-12 rounded-xl bg-green-50 flex items-center justify-center shadow-sm">
                <Icon className="text-2xl text-darkGreen" />
            </div>
            <div className="flex-1">
                <p className="text-sm text-gray-500">{label}</p>
                <p className="font-semibold text-gray-900 mt-1">
                    {renderValue(value)}
                </p>
            </div>
        </div>
    );
};

export default InfoCard; 